import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    form: {
      width: '100%',
    },

    dropzonestyle: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '36px',
      backgroundColor: '#fff',
      borderRadius: 10,
      border: '2px solid #a29c9933',
      color: '#4B403A',
      outline: 'none',
      transition: 'border .24s ease-in-out',
      width: '100%',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        padding: theme.spacing(2),
        width: '100%',
      },
    },
    dropzonetitle: {
      display: 'contents',
      alignItems: 'center',
    },
    dropzonetext: {
      color: '#4B403A',
      fontSize: 16,
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      textAlign: 'center',
    },
    dropzoneortext: {
      color: '#4B403A',
      fontSize: 16,
      margin: theme.spacing(1),
      lineHeight: '18px',
    },
    dropzonenote: {
      color: '#4B403A',
      fontSize: 14,
      textAlign: 'right',
      margin: theme.spacing(0),
    },

    thumbsContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    },
    thumb: {
      display: 'inline-flex',
      border: '2px solid #ffffff',
      backgroundColor: '#ffffff',
      marginRight: '10px',
      width: '60px',
      height: '60px',
      boxSizing: 'border-box',
      position: 'relative',
      borderRadius: '2px',
      overflow: 'hidden',
      '&:hover': {
        borderTop: '2px solid #002a4d',
        borderBottom: '2.5px solid #002a4d',
        borderLeft: '2px solid #002a4d',
        borderRight: '2px solid #002a4d',
        borderRadius: '2px',
        '& $cross': {
          display: 'block',
        },
      },
    },
    thumbInner: {
      display: 'flex',
      minWidth: 0,
      overflow: 'hidden',
    },
    img: {
      display: 'block',
      width: 'auto',
      height: '100%',
    },
    cross: {
      display: 'none',
      position: 'absolute',
      top: '0%',
      right: '0%',
      textAlign: 'center',
      cursor: 'pointer',
      padding: 0,
      width: '100%',
      height: '100%',
      borderRadius: '0',
      backgroundColor: 'rgba(255, 255, 255, 0.8)!important',
    },
  };
});

export default useStyles;
